import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { Cnt } from "../../Cnt.ThreeDeeCrate.Public.SDK/Cnt.ThreeDeeCrate.Public.SDK";
import { AppSettings } from "../../AppSettings";
import { EMPTY_GUID } from "../../types/Guid";

interface BuyButtonProps {
  containerId: string;
  priceId: string;
}

export const BuyButton: React.FC<BuyButtonProps> = ({ containerId, priceId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleBuy = async () => {
    setLoading(true);
    setError(null);

    try {
      const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.PublicAPIUrl);
      const result = await api.subscription.GetPurchaseUrl({
              Url: window.location.href,
              ContainerId: containerId || EMPTY_GUID,
              PriceId: priceId
            });

      if (!result?.Url) {
        throw new Error("Purchase URL not found.");
      }

      // Redirect to the purchase page
      window.location.href = result?.Url;
    } catch (err) {
      console.error("Failed to retrieve purchase URL", err);
      setError("Unable to redirect to purchase page.");
      setLoading(false); // only stop spinner on failure; redirect ends flow otherwise
    }
  };

  return (
    <>
      <button className="btn btn-primary" onClick={handleBuy} disabled={loading}>
        {loading ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Redirecting to payment...
          </>
        ) : (
          "Buy Now"
        )}
      </button>
      {error && <div className="text-danger mt-2">{error}</div>}
    </>
  );
};
